import { render } from "./Breadcrum.vue?vue&type=template&id=2e6a42c4"
const script = {}

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__